import { render, staticRenderFns } from "./AssignRoleOnBehalfOf.vue?vue&type=template&id=721d3444&"
import script from "./AssignRoleOnBehalfOf.vue?vue&type=script&lang=ts&"
export * from "./AssignRoleOnBehalfOf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports